import type { Topic, TopicStatus } from "../types";

export type Urgency = "overdue" | "soon" | "scheduled" | "none";

export function publishUrgency(date: string | null, status: TopicStatus, today: string): Urgency {
  if (!date || status === "已完成" || status === "不做") return "none";
  if (date < today) return "overdue";
  const target = Date.parse(`${date}T00:00:00+08:00`);
  const current = Date.parse(`${today}T00:00:00+08:00`);
  if (!Number.isFinite(target) || !Number.isFinite(current)) return "scheduled";
  const days = Math.round((target - current) / 86_400_000);
  return days <= 2 ? "soon" : "scheduled";
}

export function monthCells(year: number, monthIndex: number): Array<{ date: string | null; day: number | null }> {
  const days = new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
  const offset = (new Date(Date.UTC(year, monthIndex, 1)).getUTCDay() + 6) % 7;
  const cells: Array<{ date: string | null; day: number | null }> = [];
  for (let index = 0; index < offset; index += 1) cells.push({ date: null, day: null });
  for (let day = 1; day <= days; day += 1) {
    const month = String(monthIndex + 1).padStart(2, "0");
    const dayText = String(day).padStart(2, "0");
    cells.push({ date: `${year}-${month}-${dayText}`, day });
  }
  while (cells.length % 7 !== 0) cells.push({ date: null, day: null });
  return cells;
}

export function topicsOnDate(topics: Topic[], date: string): Topic[] {
  return topics.filter((topic) => !topic.inTrash && topic.status !== "不做" && topic.plannedPublishDate === date);
}
